export default "__VITE_ASSET__e9eecf32__"